import { exportIndividualsAdditionalData } from "@services/individuals/additionalData/export";
import { INDIVIDUAL_ADDITIONAL_DATA_EXPORT_HEADS } from "@typings/entities/individuals/additionalData/export";
import { exportToCSV, formatCSVData } from "@utils/export";
import { actualDateTime, formatDateTime } from "@utils/formatters";
import { useState } from "react";
import { toast } from "react-toastify";

export function useExportIndividualsAdditionalData() {
  const [isLoading, setIsLoading] = useState(false);

  const handleExport = async (individualId?: string) => {
    setIsLoading(true);
    try {
      const response = await exportIndividualsAdditionalData(individualId);

      if (!response.items?.length) {
        toast.warning("Nenhum dado adicional disponível para exportar");
        return;
      }

      const translatedData = response.items.map((item) => ({
        ...item,
        weightKg: item.weightKg ?? "",
        ageYear: item.ageYear ?? "",
        observations: item.observations ?? "",
        recaptureLatitude: item.recaptureLatitude ?? "",
        recaptureLongitude: item.recaptureLongitude ?? "",
        createdAt: formatDateTime(item.createdAt),
        updatedAt: formatDateTime(item.updatedAt),
      }));

      const formattedData = formatCSVData(
        translatedData,
        INDIVIDUAL_ADDITIONAL_DATA_EXPORT_HEADS,
      );
      exportToCSV(
        formattedData,
        `relatorio_dados_adicionais_individuo_${actualDateTime()}`,
      );
      toast.success("Dados adicionais exportados com sucesso!");
    } catch {
      toast.error("Erro ao exportar dados adicionais");
    } finally {
      setIsLoading(false);
    }
  };

  return { handleExport, isLoading };
}
